import { ReactNode } from "react";

export const StepAccordionGroup = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col divide-y divide-solid divide-slate-200 overflow-hidden rounded-md border border-solid border-slate-200">
    {children}
  </div>
);
